<template>
  <div class="vtour" :class="{ vtour__overlay: showOverlay }">
    <div class="vtour__onboarding text-white" v-if="!tourStart">
      <div class="vtour__left"></div>
      <div class="vtour__right">
        <header class="vtour__right__header">
          <div class="vtour__close-btn" @click="close"></div>
        </header>
        <h1>Take a quick tour</h1>
        <div class="vtour__right__content">
          <p class="vtour__right__content__text">
            To start using SPACEIN, we invite you to join this short guided tour of the platform – in 2 minutes or less you will be a SPACEIN pro.
          </p>
        </div>
        <footer>
          <button class="start-button text-light-grey-o" @click="remind">Remind me later</button>
          <button class="start-button text-white bg-light-green" @click="start">Start</button>
        </footer>
      </div>
    </div>

    <v-tour name="vtour" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.steps[tour.currentStep]"
            :key="tour.currentStep"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="close"
            :skip="close"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            :class="{ 'no-arrow': tour.currentStep == 0 }"
          >
            <template>
              <div slot="header" class="vtour__title">
                <div class="vtour__close-btn bg-light-black" @click="close"></div>
                <h2>{{ tour.steps[tour.currentStep].header.title }}</h2>
              </div>
              <div slot="content" class="vtour__content" v-html="tour.steps[tour.currentStep].content"></div>
              <div slot="actions" class="footer">
                <div class="vtour__steps">
                  <span class="text-white">{{ tour.currentStep + 1 }} </span>
                  / <span class="text-grey"> {{ tour.steps.length }}</span>
                </div>
                <button @click="tour.previousStep" class="start-button text-grey" v-if="tour.currentStep !== 0">Back</button>
                <button
                  @click="tour.nextStep"
                  class="start-button text-white bg-light-green"
                  v-if="tour.currentStep !== tour.steps.length - 1"
                >
                  Next
                </button>
                <button
                  @click="close"
                  class="start-button text-white bg-light-green"
                  v-if="tour.currentStep == tour.steps.length - 1"
                >
                  Close
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { promiseTime } from '@/functions/utility.js';

export default {
  name: 'Onboarding',
  data() {
    return {
      tourStart: false,
      showOverlay: true
    };
  },
  computed: {
    ...mapGetters({
      isDesktop: 'viewport/isDesktop',
      isMobile: 'viewport/isMobile'
    }),
    steps() {
      return [
        {
          header: {
            title: 'This is your Space'
          },
          target: '[data-v-step="0"]',
          content: `Here you can see who’s connecting with who.<br><br>
            The white Room is your Space’s HUB, where you can see who is
            in the platform and available to talk.<br><br>
            Any other Room represents a conversation that is currently happening.<br><br>
           You can click on the Enter button to create a new Room.<br><br>
           <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="70" height="70" viewBox="0 0 68 68">
            <defs>
              <filter id="Path_3849" x="0" y="0" width="68" height="68" filterUnits="userSpaceOnUse">
                <feOffset input="SourceAlpha"/>
                <feGaussianBlur stdDeviation="2" result="blur"/>
                <feFlood flood-opacity="0.161"/>
                <feComposite operator="in" in2="blur"/>
                <feComposite in="SourceGraphic"/>
              </filter>
            </defs>
            <g id="Component_247_4" data-name="Component 247 – 4" transform="translate(6 6)">
              <g transform="matrix(1, 0, 0, 1, -6, -6)" filter="url(#Path_3849)">
                <path id="Path_3849-2" data-name="Path 3849" d="M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z" transform="translate(6 6)" fill="#2c2c2c"/>
              </g>
              <path id="Path_3850" data-name="Path 3850" d="M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z" opacity="0.2"/>
              <g id="Group_15395" data-name="Group 15395" transform="translate(-916.041 -386.42)">
                <line id="Line_2078" data-name="Line 2078" y2="20" transform="translate(944.041 404.42)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
                <line id="Line_2079" data-name="Line 2079" x2="20" transform="translate(934.041 414.42)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
              </g>
              <g id="Path_3851" data-name="Path 3851" transform="translate(2.781 2.781)" fill="none" opacity="0.5">
                <path d="M25.22,0A25.22,25.22,0,1,1,0,25.22,25.22,25.22,0,0,1,25.22,0Z" stroke="none"/>
                <path d="M 25.2197265625 1.999996185302734 C 22.08420562744141 1.999996185302734 19.04352569580078 2.6136474609375 16.18217468261719 3.823898315429688 C 13.41742706298828 4.9932861328125 10.93400573730469 6.667797088623047 8.800895690917969 8.800895690917969 C 6.667797088623047 10.93400573730469 4.9932861328125 13.41742706298828 3.823898315429688 16.18217468261719 C 2.6136474609375 19.04352569580078 1.999996185302734 22.08420562744141 1.999996185302734 25.2197265625 C 1.999996185302734 28.35524749755859 2.6136474609375 31.39592742919922 3.823898315429688 34.25727844238281 C 4.9932861328125 37.02202606201172 6.667797088623047 39.50544738769531 8.800895690917969 41.63855743408203 C 10.93400573730469 43.77165603637695 13.41742706298828 45.4461669921875 16.18217468261719 46.61555480957031 C 19.04352569580078 47.8258056640625 22.08420562744141 48.43945693969727 25.2197265625 48.43945693969727 C 28.35524749755859 48.43945693969727 31.39592742919922 47.8258056640625 34.25727844238281 46.61555480957031 C 37.02202606201172 45.4461669921875 39.50544738769531 43.77165603637695 41.63855743408203 41.63855743408203 C 43.77165603637695 39.50544738769531 45.4461669921875 37.02202606201172 46.61555480957031 34.25727844238281 C 47.8258056640625 31.39592742919922 48.43945693969727 28.35524749755859 48.43945693969727 25.2197265625 C 48.43945693969727 22.08420562744141 47.8258056640625 19.04352569580078 46.61555480957031 16.18217468261719 C 45.4461669921875 13.41742706298828 43.77165603637695 10.93400573730469 41.63855743408203 8.800895690917969 C 39.50544738769531 6.667797088623047 37.02202606201172 4.9932861328125 34.25727844238281 3.823898315429688 C 31.39592742919922 2.6136474609375 28.35524749755859 1.999996185302734 25.2197265625 1.999996185302734 M 25.2197265625 -3.814697265625e-06 C 39.14819717407227 -3.814697265625e-06 50.43945693969727 11.29125595092773 50.43945693969727 25.2197265625 C 50.43945693969727 39.14819717407227 39.14819717407227 50.43945693969727 25.2197265625 50.43945693969727 C 11.29125595092773 50.43945693969727 -3.814697265625e-06 39.14819717407227 -3.814697265625e-06 25.2197265625 C -3.814697265625e-06 11.29125595092773 11.29125595092773 -3.814697265625e-06 25.2197265625 -3.814697265625e-06 Z" stroke="none" fill="#fff"/>
              </g>
            </g>
          </svg>
          `,
          params: {
            highlight: true,
            placement: 'right', // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
            modifiers: {
              preventOverflow: {
                boundariesElement: document.querySelector('.lobby-page')
              }
            }
          }
        },
        {
          header: {
            title: 'View Space Information'
          },
          target: '[data-v-step="2"]',
          content: 'Click here to view info about the Space.<br>',
          params: {
            highlight: true,
            placement: this.isDesktop ? 'right-start' : 'top', // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
            modifiers: {
              preventOverflow: this.isDesktop ? {} : {
                boundariesElement: document.querySelector('.app')
              }
            }
          }
        },
        {
          header: {
            title: 'Chat'
          },
          target: '[data-v-step="5"]',
          content: '<b>This is where conversations take place.</b> <br></br> Each Space, Live Stream and Room has its own chat feed. Navigate to each location to join the conversation.',
          params: {
            highlight: true,
            placement: `${this.isDesktop ? 'right-start' : 'top'}`, // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
            modifiers: {
              preventOverflow: this.isDesktop ? {} : {
                boundariesElement: document.querySelector('.app')
              }
            }
          }
        },
        {
          header: {
            title: 'View your notifications'
          },
          target: '[data-v-step="3"]',
          content: 'Click here to review and edit your sent and received invitations.<br>',
          params: {
            highlight: true,
            placement: `${this.isDesktop ? 'right-start' : 'top'}`, // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
            modifiers: {
              preventOverflow: this.isDesktop ? {} : {
                boundariesElement: document.querySelector('.app')
              }
            }
          }
        },
        {
          header: {
            title: 'Browse external links and content'
          },
          target: '[data-v-step="4"]',
          content: 'Click here to access documents and content curated for you by your Space or event administrator.<br>',
          params: {
            highlight: true,
            placement: `${this.isDesktop ? 'right-start' : 'top'}`, // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
            modifiers: {
              preventOverflow: this.isDesktop ? {} : {
                boundariesElement: document.querySelector('.app')
              }
            }
          }
        },
        {
          header: {
            title: 'Search and invite to connect'
          },
          target: '[data-v-step="6"]',
          content:
            'You’re all set to go! <br> <br> You can now invite somebody to have a conversation. Look for another member of your Space by typing their name in the search bar. If they are available, click on the Enter button next to their name to invite them to a conversation.<br>',
          params: {
            highlight: true,
            // placement: 'bottom-start' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
            placement: 'top', // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
            modifiers: {
              preventOverflow: this.isDesktop ? {} : {
                boundariesElement: document.querySelector('.app'),
                padding: 50
              },
            }
          },
          before: async() => {
            if(this.isDesktop) this['sidebar/open']('info')
            else this['sidebar/close']()
            // because of the open/close animation on the sidebar
            await promiseTime(175)
          }
        }
      ]
    }
  },
  watch: {
    isDesktop(newVal, oldVal) {
      if(newVal !== oldVal) this.orientationChange()
    },
    isMobile(newVal, oldVal) {
      if(newVal !== oldVal) this.orientationChange()
    }
  },
  methods: {
    ...mapActions(['sidebar/open', 'sidebar/close']),
    ...mapActions({
      updateShowTour: 'tour/updateHandler',
      remindLaterHandler: 'tour/remindLaterHandler'
    }),
    close() {
      this.updateShowTour(false);
      this.$tours['vtour'].stop();
    },
    remind() {
      this.close()
      this.remindLaterHandler()
    },
    start() {
      this['sidebar/close']();
      this.tourStart = true;
      this.$tours['vtour'].start();
    },
    orientationChange() {
      let currentStep = this.$tours['vtour'].currentStep
      if(currentStep < 0) return
      this.$tours['vtour'].stop()
      setTimeout(() => this.$tours['vtour'].start(currentStep), 100)
    }
  },
  mounted() {
    if(this.isDesktop) this['sidebar/open']('info')
    else this['sidebar/close']()
  },
};
</script>
<style lang="scss" scoped>
@import '~@/scss/components/global/vtour.scss';
</style>
